import React, { useEffect, useRef, useState } from "react"

function Logo({ className = "" }) {
  const [pos, setPos] = useState({ x: 100, y: 100 });
  const [hover, setHover] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleMove = (e) => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      setPos({ x, y });
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  return (
    <section
      ref={ref}
      className={`hidden md:flex flex-col items-center justify-center ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* ЛОГОТИП */}
      <div className="relative h-40 w-40 lg:h-80 lg:w-80 flex items-center justify-center">
        <div
          className="absolute inset-0"
          style={{
            background: `
              radial-gradient(
                circle at ${pos.x}% ${pos.y}%,
                #ffea8a 0%,
                #ffd700 20%,
                #daa520 40%,
                #b8860b 60%,
                #b8860b 100%
              )
            `,
            backgroundSize: "200% 200%",
            maskImage: `url("/SAPA_logo.png")`,
            maskSize: "contain",
            maskRepeat: "no-repeat",
            maskPosition: "center",
            WebkitMaskImage: `url("/SAPA_logo.png")`,
            WebkitMaskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            transition: "background 0.1s ease-out",
          }}
        />
        <div className="absolute inset-0 rounded-full blur-xl" />
      </div>

      {/* ТЕКСТ SAPA */}
      <svg
        width="260"
        height="80"
        className="mt-6"
        style={{ overflow: "visible" }}
      >
        <defs>
          <radialGradient
            id="goldGradientDynamic"
            cx={`${pos.x}%`}
            cy={`${pos.y}%`}
            r="120%"
          >
            <stop offset="0%" stopColor="#ffd700" />
            <stop offset="20%" stopColor="#ffd700" />
            <stop offset="50%" stopColor="#daa520" />
            <stop offset="80%" stopColor="#b8860b" />
            <stop offset="100%" stopColor="#b8860b" />
          </radialGradient>
        </defs>

        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill="url(#goldGradientDynamic)"
          fontSize="24"
          fontWeight="700"
          letterSpacing="4px"
          style={{
            transition: "filter 0.3s ease-out, letter-spacing 0.3s ease-out",
            filter: hover
              ? "drop-shadow(0 0 16px rgba(255,215,0,0.15))"
              : "drop-shadow(0 0 2px rgba(255,255,255,0.1))",
          }}
        >
          Internet arnalarynyń 
        </text>
        <text
          x="50%"
          y="80%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill="url(#goldGradientDynamic)"
          fontSize="24"          fontWeight="700"
          letterSpacing="4px"
          style={{
            transition: "filter 0.3s ease-out, letter-spacing 0.3s ease-out",
            filter: hover
              ? "drop-shadow(0 0 16px rgba(255,215,0,0.15))"
              : "drop-shadow(0 0 2px rgba(255,255,255,0.1))",
          }}
        >
          sapasy
        </text>
      </svg>
    </section>
  );
}

export default Logo;
